import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";

import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const SocialProfilesModal = ({ show, onHide, profiles = {}, onSave }) => {
  const [localProfiles, setLocalProfiles] = useState({});
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  // Initialize localProfiles whenever `profiles` changes
  useEffect(() => {
    setLocalProfiles(profiles || {});
  }, [profiles]);

  const handleChange = (key, value) => {
    setLocalProfiles((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));
  };

  const onSubmit = () => {
    if (store?.profileItem?.data?.full_name) {
      const payload = {
        name: store?.profileItem?.data?.full_name || "",
        fb_profile_url: localProfiles?.facebook?.value,
        insta_profile_url: localProfiles?.instagram?.value,
        linkedin_profile_url: localProfiles?.linkedin
          ? localProfiles?.linkedin?.value
          : "",
      };
      
      dispatch(updateProfile(payload));
    }
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
      // dispatch(getViewProfile());
    }
  }, [store?.actionFlag]);

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_SOCIAL_LINKS", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_SOCIAL_LINKS" }));
    };
  }, [show, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Update your social profiles</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {localProfiles && Object.keys(localProfiles).length > 0 ? (
            Object.keys(localProfiles).map((key) => (
              <div className="col-md-6">
                <Form.Group className="form-group" key={key}>
                  <Form.Label className="col-label with-icon">
                    {localProfiles[key].icon}{" "}
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={localProfiles[key].value} // displays current URL
                    onChange={(e) => handleChange(key, e.target.value)} // updates local state
                    placeholder={`Enter your ${key} profile URL`}
                    className="col-input"
                  />
                </Form.Group>
              </div>
            ))
          ) : (
            <p>No social profiles available.</p>
          )}
        </div>

        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={store?.isLoading}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SocialProfilesModal;
